import { z } from 'zod';

const page_schema = z.object({
  page: z.coerce.number().min(1).positive(),
});

export const pageValidator = {
  validate: <T extends object>(data: T) => {
    return page_schema.parse(data);
  },
};
